import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DOOD_API } from '@config/ws.config';

export interface VivaWalletTerminalAbortResponse {
  status: 'ok' | 'ko';
}

@Injectable({
  providedIn: 'root',
})
export class VivaWalletTerminalApiService {
  constructor(private readonly httpClient: HttpClient) {}

  abortTransaction$(orderId: string): Observable<VivaWalletTerminalAbortResponse> {
    return this.httpClient.post<VivaWalletTerminalAbortResponse>(
      `${DOOD_API}/orders/${orderId}/payments/abort`,
      {},
    );
  }
}
